// actions/redirects.js
import { apiClient } from '../../helpers/apiHelperV2';
import {
  FETCH_REDIRECTS_FAILURE,
  FETCH_REDIRECTS_REQUEST,
  FETCH_REDIRECTS_SUCCESS,
} from '../actionTypes';
import { shouldFetch } from '../fetchStatus';
import { redirectsResponseSelector } from '../selectors/redirects';
import { standortUrlSelector } from '../selectors/url';
import { isServer } from '../../helpers/SSRHelper';

export const fetchRedirectsIfNeeded = () => {
  return async function (dispatch, getState) {

    const state = getState();
    const standortUrl = standortUrlSelector(state);

    const redirectsResponse = redirectsResponseSelector(state);

    if (shouldFetch(redirectsResponse.status)) {
      dispatch({ type: FETCH_REDIRECTS_REQUEST, payload: {} });

      try {
        const res = await apiClient.get(`/api/v1/standorte/${standortUrl}/redirects`);
        dispatch({
          type: FETCH_REDIRECTS_SUCCESS,
          payload: { redirects: res?.data?.data || [] },
        });
      } catch (error) {
        dispatch({
          type: FETCH_REDIRECTS_FAILURE,
          payload: { error },
        });
      }
    }
  };
};